<template>
  <!--iframe class="animated slideInRight" 
  :src="`/slide/${$route.params.slideid}/${$route.params.slide}`"
  scrolling="yes">

  </iframe-->
  <main ref="main" @key.esc="doSomething">
    <article      
      @csontextmenu="openContextMenu"      
    >
      <svg viewBox="0 0 1920 1080" preserveAspectRatio="xMidYMid meet" class="elevation-4">
        <foreignObject x="0" y="0" width="100%" height="100%">
          <div
                :style="{
              backgroundImage: `url(${(slides && slide  && slide.backgroundImage) ? slide.backgroundImage : image})`,
      backgroundSize: '100% 100%',
      backgroundPosition: 'center center',
      height: '100%',
      width: '100%',
      position: 'absolute',
      transition: 'background 3s '

    }"

          v-if="slides && slide">
            <!--transition 
            enter-active-class="animated fadeInUp slow"
    leave-active-class="animated fadeOutDown"
 >
            <h1
              :key="slide.uuid"
              
              class="display-4 slide-title"
              style="top:600px;position:fixed;display:inline-block"
            >{{slide.name}}</h1>

            </transition-->
            <template v-for="(item, n) in slide.components">
              <Widget
                v-model="slide.components[n]"
                :index="n+1"
                @delete="handleWidgetDelete"
                :key="item.uuid || new Date().getTime()"
              />
            </template>
          </div>
          <v-progress-circular v-if="!slides" :size="70" :width="7" color="purple" indeterminate />
          <div
            style="position:absolute;top:0;left;0;width:100%;height:100%;z-index:0;background:none"
            @click="changeSelection"
          />
        </foreignObject>
      </svg>
    </article>
  </main>

  <!--main ref="main">
    <article ref="slide" :style="{
      transform:`scale(${zoom})`,
      top: `${top}px`
    }">
    <h1 class="display-4 animated fadeInDown delay-2" style="top:500px;position:absolute">{{slide.name}}</h1>
      <template v-for="(item, n) in slide.components">
        <Widget v-model="slide.components[n]" :key="n"></Widget>
      </te
      mplate>
    </article>
  </main-->
  <!--main ref="main">
    <article
      ref="slide"
      :style="{
      //transform: `translate(0, 0) scale(${scale})`,
      //top: '20px'tra
      }"
      
    >
    <h1 v-if="show" class="display-4 animated fadeInDown delay-2" style="top:500px;position:absolute">{{slide.name}}</h1>

    <template v-for="(item, n) in slide.components"> 

          <Widget v-model="slide.components[n]" :key="n"></Widget>

    </template>
      <!--h1>slide ditor slide nr.. {{$route.params.slide}} {{slide.name}}</h1>
      <v-text-field v-model="slide.name" />
      <v-btn @click="save">save</v-btn>
    </article>
  </main-->
</template>
<script>
import { mapState, mapActions } from "vuex";
import { sleep } from "@/utils";
import Widget from "@/components/event/slides/widgets";
import WidgetTest from "@/components/event/slides/widgets/test";

export default {
  data() {
    return {
      scale: 0,
      show: false,
      zoom: 1,
      top: 0,
      loading: false,
      image: `https://unsplash.it/1920/1080?image=${Math.floor(
        Math.random() * 100
      ) + 1}`
    };
  },
  components: {
    Widget,
    WidgetTest
  },
  beforeRouteEnter(to, from, next) {
    // called before the route that renders this component is confirmed.
    // does NOT have access to `this` component instance,
    // because it has not been created yet when this guard is called!

    next();
  },
  beforeRouteUpdate(to, from, next) {
    // called when the route that renders this component has changed,
    // but this component is reused in the new route.
    // For example, for a route with dynamic params `/foo/:id`, when we
    // navigate between `/foo/1` and `/foo/2`, the same `Foo` component instance
    // will be reused, and this hook will be called when that happens.
    // has access to `this` component instance.

    next();
  },

  computed: {
    dummyUrl() {
      // return "https://picsum.photos/id/781/1920/1080"; //require("@/assets/rainbow.jpg");
      return `https://unsplash.it/150/300?image=${Math.floor(
        Math.random() * 100
      ) + 1}`;
      //return require("@/assets/rainbow.jpg");
    },
    slides() {
      const slideid = this.$route.params.slideid;
      return this.$store.state.slides.data[slideid];
    },
    slide() {
      const slideid = this.$route.params.slideid;
      return this.$store.state.slides.data[slideid].slides.find(
        item => item.uuid === this.$route.params.slide
      );
    },
    componentSelected() {
      return this.$store.state.editor.selectedComponent;
    },
    zoomLevel() {
      return this.$store.state.application.zoomLevel;
    }
  },
  watch: {
    zoomLevel(val) {
      // this.resize(val);
      //this.zoomInViewPort();
    },
    $route(val) {
      this.image = `https://unsplash.it/1920/1080?image=${Math.floor(
        Math.random() * 100
      ) + 1}`;
    }
  },
  created() {
    // sleep(() => this.resize(), 200);
    //  this.zoomInViewPort();

    sleep(() => (this.show = true), 600);
    console.log(this.slide);
  },
  methods: {
    ...mapActions("slides", ["insert", "set", "delete", "patch"]),
    ...mapActions("editor", ["selectComponent", "attachInlineEditor"]),
    openContextMenu(e) {
      e.preventDefault();
    },

    async changeSelection() {
      await this.selectComponent(null);
      this.attachInlineEditor(null);
    },
    doSomething() {
      alert("esc");
    },
    zoomInViewPort() {
      let FULLDWIDTH = 1920;
      let windowWith = this.$refs.main.offsetWidth;

      let containerHeight = this.$refs.main.offsetHeight / 2;
      this.top = containerHeight;

      windowWith = windowWith - 40;
      if (windowWith < FULLDWIDTH) {
        let scale = windowWith / FULLDWIDTH;
        this.zoom = scale;
      }
    },
    resize(val) {
      /*
var scale = Math.min( 
  availableWidth / contentWidth, 
  availableHeight / contentHeight 
);
      */
      let scale = val;
      if (!val) {
        let containerWidth = this.$refs.main.offsetWidth;
        let containerHeight = this.$refs.main.offsetHeight;

        let slideWidth = this.$refs.slide.offsetWidth;
        let slideheight = this.$refs.slide.offsetHeight;

        let scale = Math.min(
          containerWidth / slideWidth,
          containerHeight / slideheight
        );
        console.log("scale " + scale);
      }
      this.scale = scale;
    },
    async save() {
      try {
        let data = {
          id: this.$route.params.slideid,
          ...this.$store.state.slides.data[this.$route.params.slideid]
        };
        console.log(data);

        await this.patch(data);
      } catch (e) {
        alert(e);
      }
    },
    async handleWidgetDelete(uid) {
      let components = this.slide.components.filter(item => {
        return item.uuid !== uid;
      });
      this.slide.components = [...components];
    }
  }
};
</script>
<style scoped lang="scss">
iframe {
  width: 100%;
  height: 100%;
  border: 0;
}
main {
  width: 100%;
  height: 100%;
  overflow: auto;
  user-select: none;  
  background-color: lighten(black, 70%);
  display: flex;
  align-items: center;
  justify-content: center;
  article {
  padding: 20px;
    width: 100%;
    background-size: cover;
    transition: all 2s ease-in-out;
    user-select: none;
    .slide-title {
      background: rgba(0, 0, 0, 0.8) !important;
      width: 80%;
      z-index: 999;
      font-weight: 900;
      padding: 50px;
      text-transform: uppercase;
      color: white;
    }
    /* width: 1920px;
    height: 1080px;
      width: 100%;*/
    //transform-origin: left top;
  }
}

.aspect-ratio-box {
  /*width: 1920px;
  height: 1080px;  
  
  background-color: red;  
  border: 10px solid pink;
  transform-origin: 0,0;
  transition: .2s ease-out;*/
  //position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 2px solid pink;
}
.aspect-ratio-box-inside {
  /*top: 0;
  left: 0;
  width: 100%;
  height: 100%;*/
}
</style>